export enum ReportingComparisonScopes {
  allianceGroup = 'alliance_group',
  mga = 'mga',
  rmd = 'rmd',
}

export type ReportingComparisonScope = `${ReportingComparisonScopes}`;

export enum ReportingComparisonDatasetSelections {
  all = 'all',
  paid = 'paid',
  submit = 'submit',
}

export type ReportingComparisonDatasetSelection = `${ReportingComparisonDatasetSelections}`;

/** A single production dataset. `ReportingComparisonDatasetSelections` also allows "both". */
export enum ReportingComparisonDatasets {
  paid = 'paid',
  submit = 'submit',
}

export type ReportingComparisonDataset = `${ReportingComparisonDatasets}`;

/**
 * What a comparison table's rows are counted by.
 *
 * Only the grouping differs; the movers are not a level of their own. "Top increases" is this
 * same set sorted by premium difference and cut to a page — direction and size, which a grid
 * already says through its load options.
 */
export enum ReportingComparisonRowLevels {
  mga = 'mga',
  agent = 'agent',
}

export type ReportingComparisonRowLevel = `${ReportingComparisonRowLevels}`;
